import { useQuery } from 'react-query';
import {
  getSceneProducts,
  type GetSceneProductsParams,
  type GetSceneProductsResponse
} from '../../services/sceneProductService';

export function useGetSceneProducts(params: GetSceneProductsParams) {
  return useQuery<GetSceneProductsResponse, Error, GetSceneProductsResponse>({
    queryKey: ['scene-products', params],
    queryFn: () => getSceneProducts(params),
    refetchOnMount: false
  });
}
